import script from "./AsyncGqlTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./AsyncGqlTable.vue?vue&type=script&lang=ts&setup=true"

import "./AsyncGqlTable.vue?vue&type=style&index=0&id=601fe526&lang=scss"

const __exports__ = script;

export default __exports__